// extracted by mini-css-extract-plugin
export var box = "technology-module--box--118cb";
export var elem = "technology-module--elem--7db04";
export var flexbox = "technology-module--flexbox--f4688";
export var gatsbyRespImageBackgroundImage = "technology-module--gatsby-resp-image-background-image--6a526";
export var gatsbyRespImageLink = "technology-module--gatsby-resp-image-link--6c903";
export var img = "technology-module--img--4444a";
export var input = "technology-module--input--53d73";
export var load8 = "technology-module--load8--fe9e0";
export var loader = "technology-module--loader--53c39";
export var stack = "technology-module--stack--efc7d";
export var techLabel = "technology-module--techLabel--d3af6";